<template>
  <div class="col-10 m-0 p-0">
    <div class="col-12 row m-0 my-5 cust_card_time_div cust_card_time" @click="show_date_modal">
      <!-- 左邊div -->
      <div class="div_center m-0 d-flex flex-column flex-md-row align-items-center">
        <div class="d-block d-md-inline-block div_center">
          <img class="cust_card_icon" :src="require('@/assets/icon/Ordering_statistics.png')" />
          <label class="m-0 ml-3 cust_card_time_label">訂餐時間：</label>
        </div>
        <label class="m-0 ml-3 d-block d-md-inline-block cust_card_time_label">{{ Customer_Order.Supldt_show }}</label>
        <label class="m-0 ml-3 d-block d-md-inline-block cust_card_time_label">{{
          Customer_Order.Supltm.substring(0, 5) }}</label>
      </div>

      <!-- 右邊div -->
      <div class="div_center mr-3">
        <img class="cust_card_icon2" :src="require('@/assets/icon/編輯.png')" />
        <label class="m-0 ml-2" style="
            font-size: 1.25rem;
            color: #ec6c01;
            font-weight: 600;
            cursor: pointer;
          ">編輯</label>
      </div>
    </div>
    <div>
      <div class="col-12 row m-0 p-0 justify-content-center my-4 ">
        <!-- <label class="col-12 col-md-4 pl-4 m-0 customer_order_label text-md-left">餐廳</label>
        <b-form-select class="col-12 col-md-8 p-0 cust-input" style="font-size: 2rem; border: 0; border-radius: 5px"
          v-model="Supl">
          <b-form-select-option :value="[]">請選擇</b-form-select-option>
          <b-form-select-option v-for="(item, index) in filteredSuplList" :key="index" :value="item">{{
            item.SuplNM
          }}</b-form-select-option>
        </b-form-select> -->
        <div v-for="(item, index) in filteredSuplList" :key="index"
          class="m-0 px-2 justify-content-center d-flex flex-column align-items-center flex-fill" :class="{
            cust_card_disable: !item.selected,
            cust_card: item.selected, 'mx-md-1': index != 0 && index != filteredSuplList.length - 1, 'mr-md-1': index == 0 && filteredSuplList.length > 1, 'ml-md-1': index == filteredSuplList.length - 1 && filteredSuplList.length > 1
          }" :style="{ width: 'calc(100% / ' + filteredSuplList.length + ' + -10px)' }" @click="SuplClick(item)">
          <div class="div_center ">
            <img class="cust_card_icon" :src="require('@/assets/icon/訂位.png')" />
            <label class="m-0 w-100"
              style="font-size: 2.8rem; color: #E27814; cursor: pointer;word-break: break-word; white-space: normal;">{{
                item.SuplNM
              }}</label>
          </div>
        </div>
      </div>
      <div class="col-12 row m-0 p-0 justify-content-between my-4">
        <div class="d-flex m-0 mt-2 mr-1 justify-content-center  flex-fill" :class="{
          customer_order_model_card_disable: Customer_Order.Model == '自助吧',
          customer_order_model_card: Customer_Order.Model == '套餐'
        }" @click="change_customer_order_model('套餐')">
          <div class="div_center">
            <label class="m-0" style="font-size: 2.8rem; color: #E27814; cursor: pointer">套餐</label>
          </div>
        </div>
        <div class="d-flex m-0 mt-2 ml-1 justify-content-center  flex-fill" :class="{
          customer_order_model_card_disable: Customer_Order.Model == '套餐',
          customer_order_model_card: Customer_Order.Model == '自助吧'
        }" @click="change_customer_order_model('自助吧')">
          <div class="div_center">
            <label class="m-0" style="font-size: 2.8rem; color: #E27814; cursor: pointer">自助吧</label>
          </div>
        </div>
      </div>
      <div class="col-12 row m-0 p-0 justify-content-center my-4" style="border: 2px solid #b7b7b7; border-radius: 5px">
        <label class="col-12 col-md-4 pl-4 m-0 customer_order_label text-md-left">活動位置</label>
        <b-form-select class="col-12 col-md-8 p-0 cust-input" style="font-size: 2rem; border: 0; border-radius: 5px"
          v-model="Customer_Order.Location">
          <b-form-select-option value="">請選擇</b-form-select-option>
          <b-form-select-option v-for="(item, index) in LocalList" :key="index" :value="item.Location">{{
            item.Location
          }}</b-form-select-option>
        </b-form-select>
      </div>
      <div class="col-12 row m-0 p-0 justify-content-center my-4" style="border: 2px solid #b7b7b7; border-radius: 5px">
        <label class="col-12 col-md-4 pl-4 m-0 customer_order_label text-md-left">活動目的</label>
        <b-form-input class="col-12 col-md-8 p-0 cust-input" style="font-size: 2rem; border: 0; border-radius: 5px"
          v-model="Customer_Order.Name" placeholder="輸入活動目的">
        </b-form-input>
      </div>
      <div class="col-12 row m-0 p-0 justify-content-center my-4" style="border: 2px solid #b7b7b7; border-radius: 5px">
        <label class="col-12 col-md-4 pl-4 m-0 customer_order_label text-md-left">餐點數量</label>
        <b-form-input class="col-12 col-md-8 p-0 cust-input" style="font-size: 2rem; border: 0; border-radius: 5px"
          v-model="Customer_Order.Qty" type="number" min="0" @focus="selectAll" @keydown="-preventNegative($event)"
          placeholder="請選擇/輸入總數量">
        </b-form-input>
      </div>
      <div class="col-12 row m-0 p-0 justify-content-center my-4" style="border: 2px solid #b7b7b7; border-radius: 5px">
        <label class="col-12 col-md-4 pl-4 m-0 customer_order_label text-md-left">總預算</label>
        <b-form-input class="col-12 col-md-8 p-0 cust-input" style="font-size: 2rem; border: 0; border-radius: 5px"
          v-model="Customer_Order.Budget" type="number" min="0" @focus="selectAll" @keydown="-preventNegative($event)"
          placeholder="請輸入總預算費用">
        </b-form-input>
      </div>
      <div class="col-12 row m-0 p-0 justify-content-center my-4" style="border: 2px solid #b7b7b7; border-radius: 5px">
        <b-form-textarea class="col-12 p-0 cust-input" style="font-size: 2rem; border: 0; border-radius: 5px"
          placeholder="有特殊需求請在此註明" v-model="Customer_Order.Remark" rows="6">
        </b-form-textarea>
      </div>
      <div class="col-12 row m-0 p-0 justify-content-center my-4">
        <b-button style="
            border: 0;
            border-radius: 5px;
            background-color: #e58a37;
            width: 100%;
            font-size: 2rem;
          " @click="SaveCustomerOrder">確認</b-button>
      </div>
    </div>
    <b-modal ref="date_modal" hide-footer hide-header centered no-fade no-close-on-backdrop no-close-on-esc>
      <div class="col-12 row m-0 justify-content-end">
        <b-icon icon="x-circle-fill" style="color: #ec6c01; cursor: pointer" @click="hide_date_modal"></b-icon>
      </div>
      <div class="col-12 row m-0 mb-2">
        <label class="m-0" style="font-size: 2rem; color: #ec6c01">您想要何時拿到餐點</label>
      </div>
      <div class="col-12 row m-0 mb-2 justify-content-end">
        <img style="cursor: pointer;" :src="require('@/assets/icon/日曆.png')"
          @click="showanotherDate = !showanotherDate" />
        <label class="m-0"
          style="font-size: 1.25rem; color: #828282;padding-left: 10px;padding-right: 15px;cursor: pointer;"
          @click="showanotherDate = !showanotherDate">查看更多日期</label>
      </div>
      <div v-if="!showanotherDate" class="col-12 row m-0">
        <div class="col-5 col-sm-4 col-md-3 mt-2" v-for="(item, index) in DateList" :key="index">
          <div class="col-12 row m-0 date_modal_button p-0 div_center" :style="{
            'background-color': item.isfocus ? '#E58A37' : 'white',
            color: item.isfocus ? 'white' : 'black'
          }" @click="selectDate(item)">
            <label class="m-0 col-12 p-0 text-center" style="font-size: 1rem; cursor: pointer">{{ item.Weekday
            }}</label>
            <label class="m-0 col-12 p-0 text-center" style="font-size: 1rem; cursor: pointer">{{ item.date_show
            }}</label>
            <label class="m-0 col-12 p-0 text-center" style="font-size: 1rem; cursor: pointer">{{ index == 0 ? '今日'
              :
              '' }}</label>
          </div>
        </div>
      </div>
      <div v-else class="col-12 row m-0">
        <div class="col-12 row m-0">
          <b-form-datepicker v-model="anotherDate" class="mb-2"></b-form-datepicker>
        </div>
      </div>
      <div class="col-12 row m-0 mt-3">
        <div class="col-12 row m-0">
          <b-form-timepicker v-model="Customer_Order.Supltm" locale="zh" minutes-step="10"></b-form-timepicker>
        </div>
      </div>
      <div class="col-12 row m-0 div_center mt-4">
        <b-button style="border: 0; background-color: #e58a37; width: 80%"
          @click="final_date(showanotherDate)">確定資訊</b-button>
      </div>
    </b-modal>
    <b-modal ref="can_call_supl_modal" hide-footer hide-header centered no-fade no-close-on-backdrop no-close-on-esc>
      <div class="col-12 row m-0 justify-content-end">
        <b-icon icon="x-circle-fill" style="color: #ec6c01; cursor: pointer" @click="hide_can_call_supl_modal"></b-icon>
      </div>
      <div class="col-12 row m-0 p-0 mb-2">
        <label class="m-0 col-12 text-center" style="font-size: 1.5rem; color: #e58a37; font-weight: 700">您已訂餐完畢</label>
        <label class="m-0 col-12 text-center"
          style="font-size: 1.5rem; color: #e58a37; font-weight: 700">由專人為您服務或與餐廳聯繫</label>
        <label class="m-0 col-12 text-center" style="font-size: 1.5rem; color: #e58a37; font-weight: 700">電話：{{ Supl.Tel
        }}</label>
      </div>
      <div class="col-12 row m-0 justify-content-center mt-4">
        <div class="col-12 d-flex justify-content-center">
          <b-button style="border: 0; background-color: #e58a37; width: 120px"
            @click="hide_can_call_supl_modal">確定</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      Customer_Order: {
        Homeid: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Homeid')
        ),
        UserName: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('UserName')
        ),
        Mobile: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Mobile')
        ),
        Createmem: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Userid')
        ),
        Location: '',
        Suplnm: '',
        Supldt: '',
        Supldt_show: '',
        Supltm: '12:00:00',
        Type: '活動客製餐點',
        Model: '套餐',
        Name: '',
        Qty: 0,
        Budget: 0,
        Remark: '',
        ShopNO: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('ShopNO')
        ),
        SuplNO: ''
      },
      SuplList: [],
      Supl: [],
      MealList: [],
      DateList: [],
      select_type: '',
      Default_Meal: {
        Flowno: '',
        Homeid: '',
        Supldt: '',
        UserName: '',
        Mobile: '',
        Suplnm: '',
        SuplNO: '',
        ShopNO: '',
        Type: '',
        Model: '',
        Name: '',
        Qty: 0,
        Pricing: 0,
        Selling: 0,
        TotalSelling: 0,
        Remark: '',
        rItem: [],
        Createmem: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Userid')
        ),
        Updmem: this.$Global.Base64Utils.atou(
          this.$cookieFunc.getCookie('Userid')
        )
      },
      Menu: '',
      notes:
        '',
      select_Meal: [],
      Qty: 1,
      remark: '',
      cart_delete: [],
      Order_finish: [],
      LocalList: [],
      showanotherDate: false,
      Is_anotherDate: false,
      anotherDate: '',
      IS_ON_FIRST_PAGE: false
    };
  },
  watch: {},
  mounted() {
    this.init();
    window.addEventListener("message", this.handleMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleMessage);
  },
  methods: {
    handleMessage(event) {
      console.log("Received message event:", event);
      console.log("Message data:", event.data);

      if (event.data === "backButtonClick") {
        if (this.IS_ON_FIRST_PAGE) {
          parent.postMessage("goToHome", "*");
        } else {
          // Vue Router 返回上一頁
          this.$router.back();
        }
      }
    },
    async init() {
      await this.getDate_Modal();
      await this.GetSupl();
      this.GetLOCAL();
    },
    GetLOCAL() {
      this.LocalList = [];
      var post_data = {
        searchData: this.$Global.Base64Utils.utoa(
          JSON.stringify({
            Userid: this.$Global.Base64Utils.atou(
              this.$cookieFunc.getCookie('Userid')
            ),
            ShopNO: this.$Global.Base64Utils.atou(
              this.$cookieFunc.getCookie('ShopNO')
            )
          })
        )
      };
      this.$axios({
        method: 'post',
        url: this.$URLJson.GetLOCAL,
        data: post_data
      })
        .then((res) => {
          var data = JSON.parse(this.$Global.Base64Utils.atou(res.data));
          //console.log(data)
          this.LocalList = data;
        })
        .catch(function (error) {
          // 請求失敗處理
          console.log(error);
        });
    },
    GoAction(name) {
      this.$router.push({
        name: name
      });
    },
    //菜單
    selectDate(item) {
      for (var i in this.DateList) {
        this.DateList[i].isfocus = false;
      }
      var idx = this.DateList.findIndex(function (o) {
        return o == item;
      });
      this.DateList[idx].isfocus = true;
    },
    final_date(type) {
      if (type == false) {
        this.Is_anotherDate = false;
        var temp_item = this.DateList.filter((x) => x.isfocus == true);
        console.log(temp_item)
        if (temp_item.length > 0) {
          this.Customer_Order.Supldt = temp_item[0].date;
          this.Customer_Order.Supldt_show =
            temp_item[0].date_show + ' ' + temp_item[0].Weekday;

          this.hide_date_modal();
        }
      }
      else {
        this.Is_anotherDate = true;
        console.log(this.anotherDate)
        var temp_dt = this.anotherDate
        this.Customer_Order.Supldt = temp_dt.replaceAll('-', '/');
        this.Customer_Order.Supldt_show = Number(temp_dt.substring(5, 7)).toString() +
          '月' +
          Number(temp_dt.substring(8, 10)).toString() +
          '日 ' + this.getWeekday(temp_dt).replace('星期', '週');

        this.hide_date_modal();
      }
    },
    show_date_modal() {
      if (this.Is_anotherDate) {
        for (var i in this.DateList) {
          this.DateList[i].isfocus = false
        }
        this.showanotherDate = true;
      }
      else {
        this.showanotherDate = false;
        this.anotherDate = '';
      }
      this.$refs.date_modal.show();
    },
    hide_date_modal() {
      this.$refs.date_modal.hide();
    },
    //----取得訂餐時間選項----
    async getDate_Modal() {
      this.DateList = [];
      var n_date = await this.$Global.GetDate();
      var templist = this.getNext7Days(n_date);
      for (var i in templist) {
        //console.log(Number(templist[i].substring(5, 7)).toString() + '月' + Number(templist[i].substring(8, 10)).toString() + '日')
        this.DateList.push({
          date_show:
            Number(templist[i].substring(5, 7)).toString() +
            '月' +
            Number(templist[i].substring(8, 10)).toString() +
            '日',
          date: templist[i],
          Weekday: this.getWeekday(templist[i]).replace('星期', '週'),
          isfocus: false
        });
      }
      if (this.Customer_Order.Supldt == '') {
        this.Customer_Order.Supldt = this.DateList[0].date;
        this.Customer_Order.Supldt_show =
          this.DateList[0].date_show + ' ' + this.DateList[0].Weekday;
        this.DateList[0].isfocus = true;
      }
    },
    getNext7Days(startDate) {
      const dateArray = [];
      let currentDate = new Date(startDate);

      for (let i = 0; i < 7; i++) {
        let newDate = new Date(currentDate);
        dateArray.push(
          newDate.toLocaleDateString('zh-TW', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          })
        );
        currentDate.setDate(currentDate.getDate() + 1);
      }

      return dateArray;
    },
    getWeekday(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('zh-TW', { weekday: 'long' });
    },
    //----取得訂餐時間選項END----
    change_customer_order_model(model) {
      this.Customer_Order.Model = model;
    },
    SaveCustomerOrder() {
      this.Customer_Order.SuplNO = this.Supl.SuplNO;
      this.Customer_Order.Suplnm = this.Supl.SuplNM;

      if (this.Customer_Order.SuplNO === '' || this.Customer_Order.SuplNO === undefined || this.Customer_Order.SuplNO === null) {
        this.$parent.Msg('請選擇餐廳', '5', 'warning');
        return
      }
      if (this.Customer_Order.Location == '') {
        this.$parent.Msg('請輸入活動位置', '5', 'warning');
        return
      }
      if (this.Customer_Order.Qty == '') {
        this.$parent.Msg('請輸入餐點數量', '5', 'warning');
        return
      }
      if (this.Customer_Order.Budget == '') {
        this.$parent.Msg('請輸入總預算', '5', 'warning');
        return
      }
      this.Customer_Order.token = localStorage.token;
      const url = window.location.href

      const u = new URL(url);
      // 取得路徑
      let pathname = u.pathname; // "/dev_sampo_client_web/SpaReservedMain"
      // 去掉最後一段
      let basePath = pathname.substring(0, pathname.lastIndexOf("/") + 1);

      // 拼回完整網址
      let resultpath = `${u.origin}${basePath}`;
      this.Customer_Order.url = resultpath + 'OrderOrReservation?token=' + localStorage.token;

      var post_data = {
        searchData: this.$Global.Base64Utils.utoa(
          JSON.stringify(this.Customer_Order)
        )
      };

      this.$axios({
        method: 'post',
        url: this.$URLJson.SaveCustomerOrder,
        data: post_data
      })
        .then((res) => {
          var data = JSON.parse(this.$Global.Base64Utils.atou(res.data));
          if (data.check) {
            this.clear_customer_order();
            this.show_can_call_supl_modal();
          } else {
            this.$parent.Msg(data.msg, '5', 'warning');
          }
        })
        .catch(function (error) {
          // 請求失敗處理
          console.log(error);
        });
    },
    hide_can_call_supl_modal() {
      this.$refs.can_call_supl_modal.hide();
    },
    show_can_call_supl_modal() {
      this.$refs.can_call_supl_modal.show();
    },
    selectAll(event) {
      // 當 focus 時，選取所有文字
      event.target.select();
    },
    clear_customer_order() {

      this.Customer_Order.Homeid = this.$Global.Base64Utils.atou(
        this.$cookieFunc.getCookie('Homeid')
      );
      this.Customer_Order.UserName = this.$Global.Base64Utils.atou(
        this.$cookieFunc.getCookie('UserName')
      );
      this.Customer_Order.Mobile = this.$Global.Base64Utils.atou(
        this.$cookieFunc.getCookie('Mobile')
      );
      this.Customer_Order.Createmem = this.$Global.Base64Utils.atou(
        this.$cookieFunc.getCookie('Userid')
      );
      this.Customer_Order.Location = '';
      this.Customer_Order.Suplnm = '';
      this.Customer_Order.Supldt = '';
      this.Customer_Order.Supldt_show = '';
      this.Customer_Order.Supltm = '12:00:00';
      this.Customer_Order.Type = '活動客製餐點';
      this.Customer_Order.Model = '套餐';
      this.Customer_Order.Name = '';
      this.Customer_Order.Qty = 0;
      this.Customer_Order.Budget = 0;
      this.Customer_Order.Remark = '';
      this.Customer_Order.ShopNO = this.$Global.Base64Utils.atou(
        this.$cookieFunc.getCookie('ShopNO')
      );
      this.Customer_Order.SuplNO = '';
      this.Supl = [];
      for (var i in this.SuplList) {
        this.SuplList[i].selected = i == 0 ? true : false;
        if (i == 0) {
          this.Supl = this.SuplList[0];
        }
      }
      this.Is_anotherDate = false;
      this.getDate_Modal();
    },
    async GetSupl() {
      this.SuplList = await this.$Global.GetSuplList(
        '餐廳',
        this.$cookieFunc.getCookie('Userid'),
        this.$cookieFunc.getCookie('ShopNO')
      );
      for (var i in this.SuplList) {
        this.SuplList[i].selected = i == 0 ? true : false;
        if (i == 0) {
          this.Supl = this.SuplList[0];
        }
      }
    },
    SuplClick(obj) {
      for (var i in this.SuplList) {
        this.SuplList[i].selected = false;
      }
      obj.selected = true
      this.Supl = obj
    },
    preventNegative(e) {
      if (e.key === '-' || e.key === 'e' || e.key === '+' || e.key === '.') {
        e.preventDefault();
      }
    }
  },
  computed: {
    filteredSuplList() {
      // 這裡把要顯示的篩選好
      return this.SuplList.filter(item => item.CanOrder === '1');
    }
  }
};
</script>
<style scoped>
.cust_card_icon2 {
  width: 40px;
  height: 40px;
}

.cust_card {
  /* padding: 15px 50px 15px 50px; */
  border: 3.4px solid #E27814;
  background-color: #FFF3E2;
  border-radius: 0.5rem;
  box-shadow: 1px 1px 1px 1px #cbb79a;
  min-height: 151px;
  /* width: 100%; */
  cursor: pointer;
}

.cust_card_disable {
  /* padding: 15px 50px 15px 50px; */
  border: 1.28px solid #E27814;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 1px 1px 1px 1px #cbb79a;
  min-height: 151px;
  /* width: 100%; */
  cursor: pointer;
  /*filter: grayscale(100%);*/
}

.cust_card_vLOGO {
  /* padding: 15px 50px 15px 50px; */
  border: 1px solid white;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 1px 1px 1px 1px #cbb79a;
  height: 200px;
  width: 100%;
  max-width: 400px;
}

.cust_card_time {
  /* padding: 15px 50px 15px 50px; */
  border: 1px solid #e68533;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 1px 1px 1px 1px #cbb79a;
  min-height: 110px;
  width: 100%;
  cursor: pointer;
}

.date_modal_button {
  /* padding: 15px 50px 15px 50px; */
  border: 1px solid #dbdbdb;
  height: 80px;
  /*width: 60px;*/
  cursor: pointer;
  line-height: 10px;
}

@media (min-width: 768px) {
  .cust_card_time_label {
    font-size: 2rem;
    color: #ec6c01;
    cursor: pointer;
  }

  .cust_card_time_div {
    -ms-flex-pack: justify !important;
    -webkit-box-pack: justify !important;
    justify-content: space-between !important;
  }

  .cust_card_icon {
    width: 55px;
    height: 48px;
  }
}

@media (max-width: 767px) {
  .cust_card_time_label {
    font-size: 1.75rem;
    color: #ec6c01;
    cursor: pointer;
  }

  .cust_card_time_div {
    -ms-flex-align: center !important;
    -webkit-box-align: center !important;
    align-items: center !important;
    -ms-flex-pack: center !important;
    -webkit-box-pack: center !important;
    justify-content: center !important;
    display: -ms-flexbox !important;
    display: -webkit-box !important;
    display: flex !important;
  }

  .cust_card_icon {
    width: 40px;
    height: 40px;
  }
}

.cust_card_time_modal {
  /* padding: 15px 50px 15px 50px; */
  border: 1px solid #e68533;
  background-color: white;
  border-radius: 0.5rem;
  /* box-shadow: 1px 1px 1px 1px #CBB79A; */
  min-height: 50px;
  width: 100%;
  cursor: pointer;
}

.cust_card_icon_modal {
  width: 24px;
  height: 24px;
}

.cust_card_time_label_modal {
  font-size: 1rem;
  color: #ec6c01;
  cursor: pointer;
}

.customer_order_label {
  font-size: 2rem;
  line-height: 65px;
  background-color: white;
  border-radius: 5px;
  /* text-align: start; */
}

.customer_order_model_card {
  /* padding: 15px 50px 15px 50px; */
  border: 3.4px solid #E27814;
  background-color: #FFF3E2;
  border-radius: 0.5rem;
  box-shadow: 1px 1px 1px 1px #cbb79a;
  min-height: 255px;
  width: calc(50% + -10px);
  cursor: pointer;
}

.customer_order_model_card_disable {
  /* padding: 15px 50px 15px 50px; */
  border: 1.28px solid #E27814;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 1px 1px 1px 1px #cbb79a;
  min-height: 255px;
  width: calc(50% + -10px);
  cursor: pointer;
  /*filter: grayscale(100%);*/
}
</style>



// WEBPACK FOOTER //
// src/components/View/Meal/MealCustom.vue